import {Utils} from 'hasta-la-vista-ui-core'
import {AuthService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {

    data(){
        return {
            loading: true,
            loadingReset: false,
            valid: false,
            complete: false,
            validateUser: null,
            newPassword: '',
            isGuest: true
        }
    },

    computed: {
        resetCodeUrl() {
            return this.$route.params.resetCode
        }
    },

    methods: {
        completePasswordReset(newPassword, confirmPassword) {
            this.loadingReset = true
            var MemberId = this.validateUser.Member.MemberId
            Promise.resolve(AuthService.completePasswordReset(newPassword, this.$route.params.resetCode, MemberId)).then(
                (result) => {
                    // console.log(result)

                    if(result.success) {
                        this.loadingReset = false
                        if (this.isGuest) this.complete = true
                        else this.$router.push("/user/profile")
                    }
                },
                (error) => {
                    this.loadingReset = false
                    Promise.reject(error)
                }
            );
        },

        continueToSignIn() {
            this.$router.push("/user/login")
        }
    },

    created() {
        Promise.all([AuthService.validateResetCode(this.resetCodeUrl), AuthService.isGuestUser()]).then(
            ([result, guest]) => {
                // console.log("Validate Result", result);

                if(result.data.IsResetCodeValid) {
                    this.valid = true
                    this.loading = false
                    this.validateUser = result.data
                    this.isGuest = guest

                    // console.log(this.isGuest);
                }
            },
            (error) => {
                Promise.reject(error)
            }
        );
    },
}


// WEBPACK FOOTER //
// ./src/components/pages/user/password-validate.js